import { useEffect } from "react";
import { useSearchParams } from "react-router";
import type { ProjectId } from "@agentsaas/protocol";
import { useServices } from "../app/services";

/**
 * mock 模式下的脚本化协作场景入口：项目页 URL 带 ?mock=collab 时建出演示团队
 * （后端 + 前端 agent、仓库、任务树）。之后把任务分派给 agent，mock agent 就会发邮件、开 PR、交付、提问。
 * ?mock=assets：美术 agent + 演示资产库（图片、精灵图、GLB、生成任务）。
 * ?mock=model3d（P8）：3D 建模师链路（概念图 → 模型 → 重拓扑 → 绑骨 → 动画）、3D 任务进度、带资产选项的提问。
 */
export function useMockScenario(pid: string | undefined) {
  const { mock } = useServices();
  const [sp, setSp] = useSearchParams();
  const flag = sp.get("mock");
  useEffect(() => {
    if (!mock || !pid || (flag !== "collab" && flag !== "assets" && flag !== "model3d")) return;
    if (flag === "collab") mock.collab.seedTeam(pid as ProjectId);
    else if (flag === "model3d") mock.assets.seedModel3d(pid as ProjectId);
    else mock.assets.seed(pid as ProjectId);
    setSp(
      (cur) => {
        const next = new URLSearchParams(cur);
        next.delete("mock");
        return next;
      },
      { replace: true },
    );
  }, [mock, pid, flag, setSp]);
}
